"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sweetalert2_js_1 = require("sweetalert2/dist/sweetalert2.js");
var HegydCore = /** @class */ (function () {
    function HegydCore() {
    }
    HegydCore.sendRequest = function (url, method, data, callbackSuccess, callbackError) {
        if (callbackSuccess === void 0) { callbackSuccess = null; }
        if (callbackError === void 0) { callbackError = null; }
        $.ajax({
            url: url,
            method: method,
            data: data,
            success: function (data) {
                if (callbackSuccess) {
                    callbackSuccess(data);
                }
            },
            error: function (data) {
                if (callbackError) {
                    callbackError(data);
                }
            }
        });
    };
    HegydCore.initRemoteModal = function (selector, remoteUrl, afterLoadedCallback, successCallback, errorCallback, ajaxSubmitForm) {
        if (afterLoadedCallback === void 0) { afterLoadedCallback = null; }
        if (successCallback === void 0) { successCallback = null; }
        if (errorCallback === void 0) { errorCallback = null; }
        if (ajaxSubmitForm === void 0) { ajaxSubmitForm = null; }
        var $modal = $(selector);
        if (ajaxSubmitForm === null) {
            ajaxSubmitForm = true;
        }
        if (!$modal.length) {
            console.error('Modal not found !');
            return false;
        }
        $modal.on('hidden.bs.modal', function () {
            // let target = $(e.target);
            //  $(target).find('.modal-content:not(.static-content)').empty();
            $('.modal-content', $modal).empty();
        });
        $('.modal-content', $modal).load(remoteUrl, function () {
            if (afterLoadedCallback != undefined) {
                afterLoadedCallback();
            }
            if (ajaxSubmitForm) {
                var $form = $modal.find('form');
                var $loader = $modal.find('.loading');
                // if (!$.fn.ajaxForm) {
                //     alert('cds')
                //     return;
                // }
                var ajaxConfig = {
                    beforeSubmit: function (arr, $form, option) {
                        if ($form.attr('data-confirm') !== undefined && $form.attr('data-confirm') !== 'confirmed') {
                            sweetalert2_js_1.default({
                                animation: false,
                                customClass: 'animated fadeIn',
                                title: $form.attr("data-swal-title"),
                                text: $form.attr("data-swal-text"),
                                type: $form.attr("data-swal-type"),
                                showCancelButton: true,
                                confirmButtonText: 'Oui',
                                cancelButtonText: 'Non'
                            }).then(function (result) {
                                if (result.value) {
                                    // En cas de confirmation, on submit le formulaire normalement.
                                    // $form.removeAttr('data-confirm');
                                    $form.attr('data-confirm', 'confirmed');
                                    // var $form = $modal.find('form');
                                    $form.submit();
                                }
                            });
                            return false;
                        }
                        $('form', $modal).addClass('hide');
                        $loader.removeClass('hide');
                    },
                    success: function (data) {
                        // @ts-ignore
                        $modal.modal('hide');
                        if (successCallback != undefined) {
                            successCallback(data);
                        }
                    },
                    error: function (data, error, msg) {
                        if (errorCallback != undefined) {
                            errorCallback(data);
                        }
                        $loader.addClass('hide');
                        $('form', $modal).removeClass('hide');
                        var $error = $('<div/>').addClass('alert alert-block alert-danger')
                            .html('' +
                            '<button data-dismiss="alert" class="close close-sm" type="button">' +
                            '   <i class="fas fa-times"></i>' +
                            '</button>' + HegydCore.getModalOutputData(data.responseJSON));
                        $form.prepend($error);
                    }
                };
                // @ts-ignore
                $form.ajaxForm(ajaxConfig);
            }
        });
        // @ts-ignore
        $modal.modal('show');
    };
    HegydCore.getModalOutputData = function (data) {
        if (typeof data !== 'undefined') {
            var list = data;
            if (data.hasOwnProperty('errors'))
                list = data.errors;
            var html = '<ul>';
            $.each(list, function (key, item) {
                html += '<li>' + item + '</li>';
            });
            html += '</ul>';
            return html;
        }
        return 'Un problème est survenue lors de l\'enregistrement';
    };
    return HegydCore;
}());
exports.default = HegydCore;
